export default '4.0.0-rc.6';